import userTypes from './user.types';

export const initialState = {
  users: {}
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case userTypes.SET_ALL_USER:
      return {
        ...state,
        users: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;
